module.exports = __webpack_public_path__ + "img/plus.6b34a454.svg";